// extracted by mini-css-extract-plugin
module.exports =  {"logo":"_2zHDp301tEoCaK9kcZfKX9","register-header":"gECTq-rstlCs_4YeMqzgw"};